import React from "react";
import { Row, Col, Card, Statistic, Spin } from "antd";
import {
  SendOutlined,
  CheckCircleOutlined,
  EyeOutlined,
  LinkOutlined,
  WarningOutlined,
  StopOutlined,
} from "@ant-design/icons";

const StatsCards = ({ stats, loading }) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  const cards = [
    {
      title: "Enviados",
      value: stats.sent || 0,
      icon: <SendOutlined />,
      color: "#1890ff",
      suffix: "",
    },
    {
      title: "Entregues",
      value: stats.delivered || 0,
      icon: <CheckCircleOutlined />,
      color: "#52c41a",
      suffix: stats.sent > 0 ? `${stats.deliveryRate?.toFixed(1)}%` : "",
    },
    {
      title: "Abertos",
      value: stats.opened || 0,
      icon: <EyeOutlined />,
      color: "#13c2c2",
      suffix: stats.delivered > 0 ? `${stats.openRate?.toFixed(1)}%` : "",
    },
    {
      title: "Cliques",
      value: stats.clicked || 0,
      icon: <LinkOutlined />,
      color: "#722ed1",
      suffix: stats.delivered > 0 ? `${stats.clickRate?.toFixed(1)}%` : "",
    },
    {
      title: "Bounces",
      value: stats.bounced || 0,
      icon: <WarningOutlined />,
      color: "#fa8c16",
      suffix: stats.sent > 0 ? `${stats.bounceRate?.toFixed(1)}%` : "",
    },
    {
      title: "Reclamacoes",
      value: stats.complained || 0,
      icon: <StopOutlined />,
      color: "#f5222d",
      suffix: stats.sent > 0 ? `${stats.complaintRate?.toFixed(1)}%` : "",
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {cards.map((card) => (
        <Col xs={24} sm={12} md={8} lg={4} key={card.title}>
          <Card
            bordered={false}
            style={{
              borderTop: `3px solid ${card.color}`,
            }}
          >
            <Statistic
              title={
                <span>
                  {React.cloneElement(card.icon, {
                    style: { color: card.color, marginRight: 8 },
                  })}
                  {card.title}
                </span>
              }
              value={card.value}
              suffix={
                card.suffix && (
                  <span style={{ fontSize: 14, color: "#888" }}>
                    ({card.suffix})
                  </span>
                )
              }
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default StatsCards;
